import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import AboutUs from "./components/aboutus/AboutUs";
import Contact_us from "./components/contact_us/Contact_us";
import Privacy_policy from "./components/privacy_policy/Privacy_policy";
import Terms_condition from "./components/terms_conditions/Terms_condition";

function App() {
  return (
    <>
      {/* <ScrollToTop /> */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<Contact_us />} />
        <Route path="/privacy-policy" element={<Privacy_policy />} />
        <Route path="/terms-condition" element={<Terms_condition />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
